// extracted by mini-css-extract-plugin
export default {"layout":"wN8v9y1D","content":"S0VrWqCQ","siderContainer":"PSt4LUKq"};